import React from 'react';
import { HomeView } from '../components';

export const HomePage = () => {
  return <HomeView />;
};
